import { TreeItem } from './types';

export const buildTree = <T>(
  flatItems: TreeItem<T>[],
  parentId: string | null = null,
): TreeItem<T>[] => {
  return flatItems
    .filter((item) => item.parentId === parentId)
    .map((item) => ({
      ...item,
      children: buildTree(flatItems, item.id),
    }));
};

export const getChildren = <T>(items: TreeItem<T>[], id: string): TreeItem<T>[] => {
  return items.filter((item) => item.parentId === id);
};

export const filterTreeWithDescendants = <T>(
  items: TreeItem<T>[],
  keyword: string,
  matchFn: (item: TreeItem<T>) => boolean,
): TreeItem<T>[] => {
  return items
    .map((item) => {
      const children = filterTreeWithDescendants(item.children || [], keyword, matchFn);
      const isMatch = matchFn(item);
      if (isMatch) {
        return {
          ...item,
          children: item.children || [],
        };
      }
      if (children.length > 0) {
        return {
          ...item,
          children,
        };
      }
      return null;
    })
    .filter(Boolean) as TreeItem<T>[];
};
